import React, { Component } from 'react'

import PropTypes from 'prop-types'

export default class OffsetLoadMoreButton extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    noLoadMoreData: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    searchError: PropTypes.string,
    loadMoreText: PropTypes.string,
  }
  static defaultProps = {
    loadMoreText: 'Load More',
  }

  render() {
    const { isLoading, onClick, noLoadMoreData, searchError, loadMoreText } = this.props
    return (
      <div className="text-center">
        {searchError && <div className="text-center">{searchError}</div>}
        {noLoadMoreData ? (
          <div className="text-center"> No more feeds </div>
        ) : (
          <button onClick={onClick} disabled={isLoading} className="btn btn-primary">
            {isLoading ? 'Loading...' : loadMoreText}
          </button>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/pagination/OffsetLoadMoreButton.js